const heb_translate =  {
  buttons: {
    login: 'כניסה',
  },
  titles: {
    marketTitle: 'כותרת',
  },
}
export default heb_translate;